import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { message, Upload, Modal } from 'antd';
import { RcFile } from "antd/es/upload";
const { Dragger } = Upload;

interface propsInterface extends UploadProps {
  onSuccess?: (info: any) => void;
  onError?: (info: any) => void;
}

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });

const GroupUpload = (
  {
    action,
    headers,
    data,
    name,
    directory,
    beforeUpload,
    onSuccess,
    onError,
    listType,
    onRemove,
    className
  }: propsInterface
) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const props: UploadProps = {
    multiple: !directory,
    directory: directory,
    action: action,
    headers: headers,
    data: data,
    name: name,
    beforeUpload: beforeUpload,
    listType: listType,
    showUploadList: !!listType,
    onRemove: onRemove,
    onPreview: handlePreview,
    onChange(info) {
      const { status } = info.file;

      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
        onSuccess && onSuccess(info.file.response);
      } else if (status === 'error') {
        message.error(`${info.file.name} ${info.file.response[0]} file upload failed.`);
        onError && onError(info);
      }
    }
  }

  return (
    <div className={className}>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          {directory ? 'Click to select a folder to upload' : 'Click or drag files to this area to upload'}
        </p>
        <p className="ant-upload-hint">
          {directory ? 'All files in the folder will be uploaded preserving structure.' : 'Support for a single or bulk upload.'}
        </p>
      </Dragger>

      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  )
}

export default GroupUpload;
